import React, { useContext } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

const SaveTimeInfo: React.FC = () => {
  let { localUpdatedAt, serverUpdatedAt, setLoadingDialogOpen } = useContext(ChillerLogsContext);

  return (
    <Grid container style={{ alignItems: 'right', marginLeft: -5, maxWidth: 'unset', width: 1378 }}>
      {localUpdatedAt && (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Typography style={{ fontSize: 13 }}>Last save to device: {localUpdatedAt}</Typography>
        </Grid>
      )}
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Typography style={{ fontSize: 13 }}>Last save to server: {serverUpdatedAt}</Typography>
      </Grid>
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" color="secondary">
          <Typography style={{ fontSize: 12 }} onClick={() => setLoadingDialogOpen(true)}>
            Reset Form
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

export default SaveTimeInfo;
